import { useCallback, useState } from 'react'

interface UseTooltipStateProps {
  isOpen?: boolean
  onOpenChange?: (isOpen: boolean) => void
}

interface UseTooltipStateReturn {
  currentIsOpen: boolean
  handleOpenChange: (newIsOpen: boolean) => void
  handleToggle: () => void
}

export function useTooltipState({
  isOpen,
  onOpenChange,
}: UseTooltipStateProps): UseTooltipStateReturn {
  const [internalIsOpen, setInternalIsOpen] = useState(false)

  const currentIsOpen = isOpen !== undefined ? isOpen : internalIsOpen

  const handleOpenChange = useCallback(
    (newIsOpen: boolean) => {
      if (isOpen === undefined) {
        setInternalIsOpen(newIsOpen)
      }

      onOpenChange?.(newIsOpen)
    },
    [isOpen, onOpenChange]
  )

  const handleToggle = useCallback(() => {
    handleOpenChange(!currentIsOpen)
  }, [currentIsOpen, handleOpenChange])

  return {
    currentIsOpen,
    handleOpenChange,
    handleToggle,
  }
}
